import './style.scss';

import { IconBaseProps } from 'react-icons';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const LoadingIndicator = (props: IconBaseProps) => {
  return <AiOutlineLoading3Quarters {...props} className={'loading-indicator'} />;
};
export default LoadingIndicator;
